/// <reference path="dataservicebase.ts" />
/// <reference path="../models/meevo.model.custom.ts" />
/// <reference path="datamaintenance.interface.ts" />
/// <reference path="../models/meevo.dtos.d.ts" />
/// <reference path="../modal/modal.interface.ts" />
/// <reference path="../common/identity.service.ts" />
/// <reference path="../common/common.interface.ts" />


module Meevo.Components.BaseClasses {

    import ICustomDataContextConfig = Meevo.Model.ICustomDataContextConfig;
    import IUsageTrackingTmpObj = Meevo.Components.CommonClasses.IUsageTrackingTmpObj;

    /**
     * Maintenance Form base class.  Supplies all of the constructs for CRUD & manangement of sections.
     * The primary section CRUD is managed by this form.  Non-Primary sections CRUD is managed internally by their
     * custom implementation.
     */
    export abstract class DataMaintenanceContextBase implements IDataMaintenanceContext {
        itemId: Guid;
        private _asLocationId: number;
        sections: IDataMaintenanceSection<Model.DataMaintenance>[] = [];
        selectedSection: IDataMaintenanceSection<Model.DataMaintenance>;
        headerContent = "";
        searchResultItemTemplate = "{{displayName}}";
        searchResultTemplateFunction: any;
        locationFieldList: { field: string, label: string, checked: boolean }[] = [];
        preventUsageTracking?: boolean;
        entityType = "";
        

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        protected securityChecker: Meevo.Components.Common.ISecurityService;

        protected appSettings: Meevo.Components.Common.IAppSettings;
        protected dataService: IDataService;
        protected modalService: Meevo.Components.Modal.IModalService;
        protected identityService: Meevo.Components.Common.IIdentityService;
        protected loggingService: Meevo.Components.Logging.ILoggingService;
        protected trackingService: Meevo.Components.Tracking.ITrackingService;
        protected $controllersScope: ng.IScope;

        protected baseEndpoint: string;
        protected sectionTemplatePath: string;
        protected loadingInProgress: boolean;
        protected saveInProgress: boolean = false;
        protected mode: Meevo.Model.MaintenanceFormState;
        protected isLoaded: boolean;
        protected isUndeleteAction: boolean;

        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected copySecurityKey: string;
        protected deleteSecurityKey: string;
        protected changeAccessSecurityKey: string;
        protected changeOwnerSecurityKey: string;
        protected availableToLocationsSecurityKey: string;

        protected customDataContextConfig: ICustomDataContextConfig = null;
        protected translateService: angular.translate.ITranslateService = null;
        protected filterService: angular.IFilterService = null;


        /*protected unDeleteSecurityKey:string;*/
        public ownedByLocationName: string;
        public atLocationName: string;
        public availableAtLocations: string;
        public totalLocations: string;
        public locationId: number;
        public homeLocationId: number;
        public lockAvailableToLocations: boolean;
        public closeCallback: Meevo.Components.BaseClasses.CloseContextCallback;
        public showAllBusinesType: boolean = true;
        //public securityController: Meevo.Components.BaseClasses.DataMaintenanceSecurityController;
        public canLocationAddUser?:number = null;
        public isFilterHidden: boolean = false;
        public atLocationId: number;
        public get customTabId(): number {
            return null;
        }

        public get customTabSecurityKey(): string {
            return null;
        }

        public get customSecurityEntity(): number {
            return null;
        }

        /**
         * Instantiantes the service with the necessary dependencies.
         * @param appSettings
         * @param dataService
         * @param modalService
         * @param identityService
         * @param loggingService
         * @param securityChecker
         * @param trackingService
         * @param securityController
         * @param customDataContextConfig?
         * @param allowSectionsInitialization? - determines behavior of sections initiailization
         * @returns {}
         */
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            customDataContextConfig?: ICustomDataContextConfig,
            allowSectionsInitialization: boolean = true,
            translateService?: angular.translate.ITranslateService,
            filterService?: angular.IFilterService
        ) {

            this.appSettings = appSettings;
            this.dataService = dataService;
            this.modalService = modalService;
            this.identityService = identityService;
            this.loggingService = loggingService;
            this.trackingService = trackingService;
            this.translateService = translateService;
            this.filterService = filterService;


            this.customDataContextConfig = customDataContextConfig;
            if (customDataContextConfig) {
                this.$controllersScope = customDataContextConfig.$controllersScope;
            }
            this.setMode(Model.MaintenanceFormState.Readonly);
            this.securityChecker = securityChecker;


            if (allowSectionsInitialization) {
                this.initializeSections();

                if (this.customDataContextConfig && this.customDataContextConfig.appAreaTabs.length > 0) {
                    this.renderCustomSections();
                }
            }

            // If on mobile and transactionId is included upon load, show result view as default instead of filter view
            if (device.mobile()) {
                this.isFilterHidden = true;
            }
            // TODO: Add implementation to internally add CO tab for a generic solution
        }

        /**
         * Responsible for initializing all sections belonging to the maintenance service.
         * @return {}
         */
        protected abstract initializeSections(): void;

        /**
         * Responsible for initializing all custom sections belonging to the maintenance service.
         * @return {}
         */
        protected renderCustomSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsBaseDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: 'app/components/baseClasses/customSectionContent.html',
                isPrimarySection: false,
                handlesOwnCrud: false,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                appSettings: this.appSettings,
                identityService: this.identityService,
                sectionSecurityKey: this.customTabSecurityKey,
                noun: this.customDataContextConfig.udfNoun || null
            };

            this.customDataContextConfig.appAreaTabs.forEach((tab) => {

                if (tab.isMain) {
                    let mainSection = _.find(this.sections, s => s.isPrimarySection) || _.find(this.sections, s => this.securityChecker.hasSecurity(s.sectionSecurityKey))

                    // defined business type
                    if (tab.businessType_TId) {
                        mainSection.tabInfo = tab;
                    } else {
                        // all business types
                        mainSection.tabInfoAllBusinessType = tab;
                    }
                } else {
                    let customSection = new CustomSection(angular.extend({}, baseSectionProps, {
                        sectionId: this.customTabId === null ?
                            Math.max(...this.sections.map((section) => section.sectionId)) + 1
                            : this.customTabId,
                        displayNameContentKey: tab.displayName,
                        sectionSecurityKey: this.customSecurityEntity === null ? baseSectionProps.sectionSecurityKey
                            : `custom_entity_${this.customSecurityEntity}_${tab.tab_TId}` 
                    }));
                    customSection.tabInfo = tab;

                    this.sections.push(customSection);
                }
            });
        }

        //protected abstract copyLogic():void;

        /**
         * Responsible for initializing the header of the maintenance service.
         * This gets called only if isPrimarySection = true.  It supplies the model loaded
         * for the section to the method so that dynamic content can populate the header.
         * @return {}
         */
        protected abstract initializeHeader(model: any): void;

        public cleanup(): void {
        }

        /**
         * Activates the data maintenance form and selects the first section.
         * If the itemId is empty, this will move the form into 'Add' mode.
         * Otherwise, it will call the dataserve to load the item.
         * @param {Guid} itemId - the maintenance item to load.
         * @returns {}
         */
        activate(itemId: Guid, sectionContentKey?: string, asLocationIdLocal?: number, subSectionContentKey?: string) {

            if (!this.sections || this.sections.length === 0) {
                // No sections were defined for the current maintenance area.
                // Most likely, all sections were disabled b/c of security configuration.
                // In this case, show the default content which indicates the user doesn't
                // have access to the area.
                this.sectionTemplatePath = "";

                this.sections.push(new DefaultSection(1, "SECTION_DEFAULT_ACCESS_DENIED",
                    "app/components/baseClasses/defaultSectionContent.html",
                    false, true, "", "", this.loggingService, this.dataService, this.identityService, Model.NounEnum.ServiceAddOnMapping, this.appSettings));
            }

            //Compile handlebars template so it can be used within instantiated contexts.
            this.searchResultTemplateFunction = Handlebars.compile(this.searchResultItemTemplate);

            this.itemId = itemId;
            if (Model.Guard.isSomething(asLocationIdLocal) && asLocationIdLocal !== 0)
                this.asLocationId = asLocationIdLocal;
            else
                this.asLocationId = null;

            // Determine whether to enter Add or Edit mode based on the presence of an ItemId.
            if (Model.Guard.isNothing(this.itemId) || this.itemId.toString() === "") {
                this.loggingService.trace(`Adding a NEW Item`);

                this.initializeForAdd(this.sections[0]);
            } else {
                this.loggingService.trace(`Opening Item: ${itemId}`);

                for (let i = 0; i < this.sections.length; i++) {
                    this.sections[i].setParentItemId(this.itemId);
                }

                this.initializeForEdit();

                if (Model.Guard.isSomething(sectionContentKey)) {
                    var matchingSections = this.sections.filter(section => section.displayNameContentKey === sectionContentKey);
                    if (matchingSections.length > 0) {
                        this.selectSection(matchingSections[0], subSectionContentKey);
                        return;
                    }
                }

                let defaultIndex = _.findIndex(this.sections, s => s.sectionSecurityKey ? this.securityChecker.hasSecurity(s.sectionSecurityKey) : true);
                if (Model.Guard.isSomething(this.sections[defaultIndex]))
                    this.selectSection(this.sections[defaultIndex], subSectionContentKey);
            }
        }

        /**
         * Prepares the maintenance form for adding a new item.
         * @param {IDataMaintenanceSection} item
         * @returns {}
         */
        initializeForAdd(item: IDataMaintenanceSection<Model.DataMaintenance>): void {
            this.selectedSection = item;
            this.selectedSection.createInstance((data: any) => this.initializeHeader(data));
            if (this.homeLocationId == this.identityService.current().centralOfficeId) {
                this.lockAvailableToLocations = false;
            }
            this.selectedSection.getTabAnswers();
            this.setMode(Model.MaintenanceFormState.Adding);
            this.selectSection(item);
            this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null);
        }

        updateCoBarData(data: any) {
            if (Model.Guard.isSomething(data) && Model.Guard.isSomething(data.homeLocationId))
                this.homeLocationId = data.homeLocationId;
            if (Model.Guard.isSomething(data) && Model.Guard.isSomething(data.locationId))
                this.locationId = data.locationId;

            if (Model.Guard.isSomething(data) && Model.Guard.isSomething(data.ownedByLocationName))
            {
                this.ownedByLocationName = data.ownedByLocationName;
                this.atLocationName = data.atLocationName;
                this.availableAtLocations = data.availableAtLocations;
                this.totalLocations = data.totalLocations;

                if (this.homeLocationId !== this.identityService.current().centralOfficeId && Model.Guard.isSomething(data.businessTypeDetail)) {
                    data.businessTypeDetail = null;
                }
                this.lockAvailableToLocations = Model.Guard.isSomething(data.availableToLocations) && data.availableToLocations;
            }
                         
            
        }

        /**
         *  Prepares the mainteance form for editing a selected item.
         *  @returns {}
         */
        initializeForEdit() {
            this.setMode(Model.MaintenanceFormState.Readonly);
        }

        setFocusOnField(field: any, actionState: any) {
        }

        setFilter(filter: number) {
        }

        /**
         * Verifies specified section of the maintance form is accessible before selecting it.
         * @param {IDataMaintenanceSection} item
         * @returns {}
         */

        /**
         * Selects the specified section of the maintance form and activates it.
         * @param {IDataMaintenanceSection} item
         * @returns {}
         */
        public selectSection(item: IDataMaintenanceSection<Model.DataMaintenance>, subSectionContentKey?: string): void {

            /* 
             * client record management does not trigger the interop if the client tab is already open with the same client
             * so just let any request from client record management through (ADO: 115489)
             */
            let skipComparison = false;
            if (item['contextParams'] && item['contextParams'].params && item['contextParams'].params.callbackState === Meevo.Model.ModuleEnum.ClientRecordManagement) {
                skipComparison = true;
            }

            if (this.selectedSection === item && !skipComparison) {
                if (this.selectedSection.isSubSectionSelected(subSectionContentKey)) {
                    return;
                }
            }

            if (this.selectedSection && this.navigationBlocked) {
                if (this.selectedSection !== item) {
                    this.modalService.alert("MESSAGE_PENDING_CHANGES");
                }
                else if (!this.isAdding) {
                    this.modalService.alert("MESSAGE_PENDING_TAB_CHANGES");
                }
                this.selectSection(this.selectedSection);
            } else {
                // Can't selected another section when adding and copying (!this.itemId)
                if (this.isAdding || this.isCopying)
                    return;

                var prevSection = this.selectedSection;
                if (Model.Guard.isSomething(prevSection))
                    prevSection.prevUnselected(); // implement prevUnselected action

                this.selectedSection = item;

                if (!this.selectedSection.handlesOwnCrud) {
                    this.loadingInProgress = true;
                    var newSectionEndPoint = this.selectedSection.sectionEndpoint;

                    let baseEndpoint = Model.Guard.isSomething(this.selectedSection.baseEndpoint) ? this.selectedSection.baseEndpoint : this.baseEndpoint;
                    this.dataService.getSectionById(baseEndpoint, this.itemId, newSectionEndPoint, this.asLocationId).then((data: any) => {
                        this.selectedSection.model = data;
                        this.selectedSection.sectionModelRetrieved();
                        this.selectedSection.activate(subSectionContentKey);

                        if (this.selectedSection.isPrimarySection) {
                            this.updateCoBarData(data);
                            this.initializeHeader(data);
                        }

                    }).finally(() => {
                        this.loadingInProgress = false;
                    });
                }
                this.selectedSection.selected(!this.selectedSection.handlesOwnCrud ? null : subSectionContentKey); // implement selected action

                this.usageTrackingLog(
                    Meevo.Model.VerbEnum.Viewed,
                    this.selectedSection instanceof CustomSection ? this.selectedSection.displayNameContentKey : null,
                    this.selectedSection.getParentItemId(),
                    this.selectedSection instanceof CustomSection ? `${Meevo.Model.AppAreaEnum[this.selectedSection.tabInfo.appAreaEnum]} ${this.selectedSection.tabInfo.displayName} ${Meevo.Model.VerbEnum[Meevo.Model.VerbEnum.Viewed]}` : null
                );
            }
        }


        public reloadSelectedSection() {
            if (!this.selectedSection.handlesOwnCrud) {
                this.loadingInProgress = true;
                let newSectionEndPoint = this.selectedSection.sectionEndpoint;

                let baseEndpoint = Model.Guard.isSomething(this.selectedSection.baseEndpoint) ? this.selectedSection.baseEndpoint : this.baseEndpoint;
                this.dataService.getSectionById(baseEndpoint, this.itemId, newSectionEndPoint, this.asLocationId).then((data: any) => {
                    this.selectedSection.model = data;
                    this.selectedSection.sectionModelRetrieved();
                    this.selectedSection.activate();

                    if (this.selectedSection.isPrimarySection) {
                        this.updateCoBarData(data);
                        this.initializeHeader(data);
                    }

                }).finally(() => {
                    this.loadingInProgress = false;
                });
            }
        }

        clearRelatedEntities(): void {
        }

        applyBusinessTypeFilter(): void {
            // Filter out CO from business type selection
            if (!this.verifySelectedSectionModel())
                return;

            if (this._takeOwnership)
                this._businessTypeAsLocationId = this.selectedSection.model.homeLocationId;
            else
                this._businessTypeAsLocationId = null;


            if (this._takeOwnership)
                this._businessTypeFilter = {
                    includeAllLocationsListItem: true,
                    onlyId: null,
                    onlyMyLocationsBusinessTypes: true
                };
            else if (this.selectedSection.model.homeLocationId === this.identityService.current().centralOfficeId)
                if (this.mode === Meevo.Model.MaintenanceFormState.Adding)
                    this._businessTypeFilter = {
                        includeAllLocationsListItem: true,
                        onlyId: null,
                        onlyMyLocationsBusinessTypes: false
                    };
                else if (this.mode === Meevo.Model.MaintenanceFormState.Editing)

                    this._businessTypeFilter = {
                        includeAllLocationsListItem: true,
                        onlyId: Model.Guard.returnSomething(this.selectedSection.model.availableToLocations) === false ? null : Model.Guard.returnSomething(this.selectedSection.model.businessTypeId),
                        onlyMyLocationsBusinessTypes: false
                    };
        }

        takeOwnershipClicked(): void {
            if (this.mode === Meevo.Model.MaintenanceFormState.Editing)
                this.usageTrackingLog(Meevo.Model.VerbEnum.TakeOwnership, null);
        }

        /**
         * Edit the selected item
         */
        edit(isUndeleting: boolean = false): void {
            if ((isUndeleting && this.canEditDeleted)|| this.canEdit) {
                this.selectedSection.takeBackup();
                this.setMode(Model.MaintenanceFormState.Editing);

                this.applyBusinessTypeFilter();
                this.usageTrackingLog(Meevo.Model.VerbEnum.EditButtonClicked, null);
            }
        }


        /**
         * Add New item
         */
        add(preventUsageTracking: boolean = false): void {

            if (this.baseEndpoint == 'employee') {
                if (this.canLocationAddUser == null) {
                    this.dataService.customMethodData("api/Employee/CanLocationAddMoreUser",
                        "GET", '', { locationId: this.identityService.locationId, excludeUserId: "00000000-0000-0000-0000-000000000000" })
                        .then(
                            result => {
                                this.canLocationAddUser = result.data;
                            })
                }

                if (this.canLocationAddUser <= 0) {
                    this.modalService.error("MESSAGE_LIMIT_EXCEEDE_USER");
                    return;
                }
            }

            this.initializeForAdd(this.sections[0]);
            this.headerContent = "";
            if (preventUsageTracking) return;
            this.usageTrackingLog(Model.VerbEnum.AddNewButtonClicked, null);
        }

        // Way to directly switch to edit state withouth all other checks.   Used initially when editing from typeahead.
        editExternal(): void {
            this.setMode(Model.MaintenanceFormState.Editing);
        }

        get isCoItemInLocation(): boolean {
            return this.verifySelectedSectionModel()
                && !this.isApplicationModeCO()
                && this.selectedSection.model.homeLocationId === this.identityService.current().centralOfficeId;
        }
        /**
         * Delete Setter/Getter for default _deleteStandardMessageKey
         */
        private _deleteStandardMessageKey: string = "MESSAGE_DELETE_CONFIRMATION";

        get deleteConfirmationMessageKey(): string {
            return this._deleteStandardMessageKey;
        }

        set deleteConfirmationMessageKey(value: string) {
            this._deleteStandardMessageKey = value;
        }

        /**
         * Deletes the selected item.
         */
        delete(): void {
            let vm = this;
            // Do not allow CO-owned items to be deleted in a location
            if (vm.isCoItemInLocation || vm.isLocationImpersonating) {
                vm.modalService.alert("MESSAGE_CANNOT_DELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (this.canDelete) {
                this.preDelete().then(() => {
                    vm.loadingInProgress = true;
                    // Patch model object state to deleted
                    vm.dataService.objectStatePatch(vm.baseEndpoint,
                        vm.itemId,
                        vm.selectedSection.model.entityVersion,
                        <number>Model.ObjectStateEnum.Deleted,
                        vm.asLocationId,
                        this.selectedSection.sectionEndpoint)
                        .then((data) => {
                            if (data) {
                                vm.selectedSection.model = data;
                                vm.selectedSection.sectionModelRetrieved();
                                vm.loggingService.trace(`Delete saved.`);
                            }
                            this.postDelete();
                        })
                        .finally(() => {
                            vm.loadingInProgress = false;
                        });
                });
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
            this.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
        }

        /**
         * Override this if you want to change the decision to delete.
         */
         preDelete(): ng.IPromise<boolean> {
            return this.modalService.warning(this.deleteConfirmationMessageKey, 0, false, { 
                showCancelButton: true, 
                cancelButtonContentKey: 'LABEL_NO', 
                cancelButtonHotKey: 'MODAL_NO_BUTTON', 
                okButtonContentKey: 'LABEL_YES',
                okButtonHotKey: 'MODAL_YES_BUTTON',
            });
        }

        postDelete(): void {
        }


        /**
         * Undelete the selected item.
         */
        undelete(activate = false, showCOWarning = true ): void {
            let vm = this;
            if (showCOWarning) {
                if (vm.isCoItemInLocation || vm.isLocationImpersonating) {
                    vm.modalService.alert("MESSAGE_CANNOT_UNDELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                    return;
                }
            }
            if (this.canUndelete) {
                this.isUndeleteAction = true;
                this.edit(true);
                vm.selectedSection.model.objectState = Model.ObjectStateEnum.Active;
                vm.selectedSection.sectionModelRetrieved();
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
            this.usageTrackingLog(Meevo.Model.VerbEnum.UndeleteButtonClicked, null);
        }

        postUndelete(): void {
        }

        setMode(newMode: Meevo.Model.MaintenanceFormState) {
            //arod: not my design;
            this.mode = newMode;
            if (Model.Guard.isSomething(this.selectedSection)) {
                this.selectedSection.mode = newMode;
                this.selectedSection.onModeChange(newMode, this);
            }
        }
        /**
         * Creates a copy of the selected section.
         * Any additional sections that implicitly need to be copied will be created on the server upon save.
         *
         * TODO: Need to pass along item copy was based on so server can create other implicit sections.
         */
        copy(): void {
            if (this.baseEndpoint == 'employee') {

                if (this.canLocationAddUser == null) {
                    this.dataService.customMethodData("api/Employee/CanLocationAddMoreUser",
                        "GET", '', { locationId: this.identityService.locationId, excludeUserId: "00000000-0000-0000-0000-000000000000" })
                        .then(
                            result => {
                                this.canLocationAddUser = result.data;
                            })
                }

                if (this.canLocationAddUser <= 0) {
                    this.modalService.error("MESSAGE_LIMIT_EXCEEDE_USER");
                    return;
                }
            }
                if (this.canCopy) {
                    this.setMode(Model.MaintenanceFormState.Copying);
                    this.selectedSection.createCopy();
                    //this.itemId = null;
                    this.postCopy();
                } else {
                    this.modalService.alert("ERROR_HTTP_403");
                }
            
        }

        postCopy(): void {
            // usage tracking for copy
            let originalModel = this.selectedSection ? this.selectedSection.originalEntity : null;
            if (originalModel) {
                this.usageTrackingLog(Meevo.Model.VerbEnum.CopyButtonClicked, null);
            }
            if (_.isFunction((<any>this.selectedSection).postCopy)) {
                (<any>this.selectedSection).postCopy();
            }
            // The purpose of this code is to handle new DB changes which require the EntityVersion to be set to 0 in order for the primary key to be generated for the appropriate model
            if (this.selectedSection != null && this.selectedSection.model != null)
                this.selectedSection.model.entityVersion = 0;
            // Since displayName is cleared out upon copy in context, headerContent needs to be initialized as well
            this.headerContent = undefined;
            this.selectedSection.model.objectState = Model.ObjectStateEnum.Active;
        }

        /**
         * Saves the item currently being edited/added.
         */
        save(): angular.IPromise<any> {
            let addingMode = this.mode === Meevo.Model.MaintenanceFormState.Adding,
                copyingMode = this.mode === Meevo.Model.MaintenanceFormState.Copying;

            if (this.canSave && !this.saveInProgress) {

                this.selectedSection.preSave();
                this.selectedSection.preSaveModel = jQuery.extend(true, {}, this.selectedSection.model);
                this.loadingInProgress = true;
                this.saveInProgress = true;

                //don't use finally on the promises below. this should be skipped if there is a warning
                //postAdd dismisses the data maint form.
                let finallyFcn = () => {
                    this.saveInProgress = false;
                    this.loadingInProgress = false;
                    this.updateCoBarData(this.selectedSection.model);

                    if (this.customDataContextConfig && this.customDataContextConfig.use) {
                        if ((addingMode || copyingMode) && this.selectedSection.customControlsModel) {
                            // if entity didn't have id (wasn't created or copied yet)

                            this.selectedSection.customControlsModel.answers.map(answer => {
                                answer.entity_Id = this.selectedSection.model.id;

                                return answer;
                            });
                        }

                        this.selectedSection.saveCustomControls();
                    }
                };
                this.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);

                if (this.mode === Meevo.Model.MaintenanceFormState.Adding || this.mode === Meevo.Model.MaintenanceFormState.Copying) {
                    if (this.identityService.inCentralOfficeMode()) {
                        if (this.identityService.userBusinessTypes.length == 1)
                            this.selectedSection.model.businessTypeDetail = this.identityService.userBusinessTypes[0];
                    }
                    return this.dataService.add(this.baseEndpoint, this.selectedSection.model, this.itemId, this.selectedSection.sectionEndpoint)
                        .then((data: any) => {
                            if (data.isWarning) {
                                this.handleWarnings(data.responseStatus.errors, data.responseStatus.message);
                            } else {
                                this.itemId = data.id;
                                for (let i = 0; i < this.sections.length; i++) {
                                    this.sections[i].setParentItemId(this.itemId);
                                }
                                this.selectedSection.model = data;
                                this.businessTypeDetail = data.businessTypeDetail;
                                this.selectedSection.sectionModelRetrieved();
                                this.setMode(Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`New item saved.`);
                                this.postAdd(this.selectedSection.model);
                                this.postSave(this.selectedSection.model);
                                finallyFcn();
                            }
                        })
                        .catch((reason: any) => {
                            this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                            //finallyFcn();
                            this.saveInProgress = false;
                            this.loadingInProgress = false;
                        });
                    // Handling location override
                } else {
                    // For overrides pass as location override contract
                    if (this._takeOwnership) {
                        this.selectedSection.model.locationId = this.identityService.current().centralOfficeId;
                        this.selectedSection.model.homeLocationId = this.identityService.current().centralOfficeId;
                        this.selectedSection.model.availableToLocations = true;
                        if (this.identityService.inCentralOfficeMode()) {
                            if (this.identityService.userBusinessTypes.length == 1) {
                                this.selectedSection.model.businessTypeDetail = this.identityService.userBusinessTypes[0];
                            }
                        }
                    }
                    var updateModel = this.isApplicationModeCO() ? <Model.IHasLocationOverride>this.selectedSection.model : this.selectedSection.model;
                    if (this.allowsCentralOfficeOptions) {
                        this.buildOverrideFieldList();
                    }
                    // To avoid updating main model to save only custom UDF data.
                    if (this.selectedSection instanceof CustomSection) {
                        this.setMode(Model.MaintenanceFormState.Readonly);
                        this.postUpdate(this.selectedSection.model);
                        finallyFcn();
                        return
                    }
                    let baseEndpoint = Model.Guard.isSomething(this.selectedSection.baseEndpoint) ? this.selectedSection.baseEndpoint : this.baseEndpoint;
                    return this.dataService.update(baseEndpoint, updateModel, this.itemId, this.selectedSection.sectionEndpoint, this.asLocationId)
                        .then((data: any) => {
                            if (data.isWarning) {
                                this.handleWarnings(data.responseStatus.errors, data.responseStatus.message);
                            } else {
                                this.selectedSection.model = data;
                                this.selectedSection.sectionModelRetrieved();
                                this.setMode(Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`Updates saved.`);
                                this.postUpdate(this.selectedSection.model);
                                if (this.isUndeleteAction) {
                                    this.isUndeleteAction = false;
                                    this.loggingService.trace(`Undelete saved.`);
                                    this.postUndelete();
                                }
                                this.postSave(this.selectedSection.model);
                                finallyFcn();
                            }
                        })
                        .catch((reason: any) => {
                            this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                            //finallyFcn();
                            this.saveInProgress = false;
                            this.loadingInProgress = false;
                            this.updateAfterUnsuccessSave();
                        });
                }
            }
        }

        // Callback when save was not successful
        updateAfterUnsuccessSave(): void {}

        /**
         * Override this method to provide custom warning prompts
         * @param warnings
         */
        handleWarningsConfirm(warnings: any[], customHeaderMessage: string = null): ng.IPromise<boolean> {
            let message: string = "";
            for (let warning of warnings) {
                message += warning.message + "<br/>";
            }
            //TODO: Translate
            message += "Do you want to continue?";
            return this.modalService.confirm(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        handleWarnings(warnings: any[], customHeaderMessage: string = null): ng.IPromise<any> {
            return this.handleWarningsConfirm(warnings, customHeaderMessage)
                .then((response: boolean) => {
                    this.saveInProgress = false;
                    if (response) {
                        this.selectedSection.model.suppressWarnings = true;
                        return this.save();
                    }
                    return response;
                })
                .finally(() => {
                    this.loadingInProgress = false;
                    this.saveInProgress = false;
                });
        }

        /**
         * Hook to add processing after save takes place.
         * @returns {}
         */
        postSave(model: any): void {
            if (Model.Guard.isSomething(model.displayName))
                this.headerContent = model.displayName;
        }

        /**
         * Hook to add processing after an add takes place.
         * @returns {}
         */
        postAdd(model: any): void {
            this.headerContent = model.displayName;
            if (Model.Guard.isSomething(this.closeCallback))
                this.closeCallback(model, true);
        }


        /**
         * Hook to add processing after an update takes place.
         * @returns {}
         */
        postUpdate(model: any): void {
            if (Model.Guard.isSomething(model.displayName))
                this.headerContent = model.displayName;
            if (Model.Guard.isSomething(this.closeCallback))
                this.closeCallback(model, true);
        }

        /**
         * Ends the edit/add session in progress.
         */
        cancel(): void {
            this.isUndeleteAction = false;
            if (this.canCancel) {
                this.usageTrackingLog(Meevo.Model.VerbEnum.CancelButtonClicked, null);
                this.selectedSection.rollbackChanges();
                this.takeOwnership = false;

                if (this.isAdding) {
                    this.setMode(Model.MaintenanceFormState.Adding);
                    this.postCancel();
                 
                    // Typically causes the form to return to the search page.
                    // Implementation of deactivate needs to be supplied by the controller.
                    this.deactivate();
                }
                else {
                    this.setMode(Model.MaintenanceFormState.Readonly);
                    this.postCancel();
                }                
            }
        }

        /**
         * Hook to add processing after a cancel takes place.
         * @returns {}
         */
        postCancel(): void {
            if (!this.isAdding)
                this.updateCoBarData(this.selectedSection.model);
            if (this.verifyContextBusinessTypeDetail())
                this.selectedSection.model.businessTypeDetail = this.businessTypeDetail;
            this.takeOwnership = false;
            if (this.verifySelectedSectionModel()) {
                if (Model.Guard.isSomething((<any>this.selectedSection.model).displayName))
                    this.headerContent = (<any>this.selectedSection.model).displayName;
            }
            if (Model.Guard.isSomething(this.closeCallback))
                this.closeCallback(this.selectedSection.model, true, true);
        }

        /**
         * Deactivates the selected context.
         * Typically this is used to switch visual state from Detail to Search model via the controller.
         */
        deactivate(): void {
            alert("'deactivate' must be implemented on the controller containing the context.  Typically this is used to switch visual state from Detail to Search model");
        }


        /**
         * Determines whether the form is in a loading state.
         */
        get isLoading(): boolean {
            return this.loadingInProgress || (this.selectedSection && this.selectedSection.loadingInProgress);
        }


        /**
         * Determines and returns if the maintenance item is in an 'Editing' state.
         * @return {boolean}
         */
        get isEditing(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Editing;
        }


        /**
         * Determines and returns if the maintenance item is in an 'Adding' state.
         * @return {boolean}
         */
        get isAdding(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Adding;
        }


        /**
         * Determines and returns if the maintenance item is in an 'Copying' state.
         * @return {boolean}
         */
        get isCopying(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Copying;
        }


        /**
         * Determines and returns if the maintenance item is in an 'ReadOnly' state.
         * @return {boolean}
         */
        get isReadonly(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Readonly;
        }


        /**
         * Determines and returns if the maintenance form is in a state that will allow editing.
         * @return {boolean}
         */
        public get canEdit(): boolean {
            return this.canEditDeleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted;
        }

        /**
         * Determines and returns if the maintenance form is in a state that will allow editing.
         * @return {boolean}
         */
        public get canEditDeleted(): boolean {
            return this.itemId &&
                this.itemId !== Guid.empty &&
                this.verifySelectedSectionModel() && !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge;
        }


        /**
         * Determines and returns if the maintenance form is in a state that will allow deletion.
         * @return {boolean}
         */
        get canDelete(): boolean {
            return this.isReadonly &&
                this.itemId !== Guid.empty &&
                this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection && !this.selectedSection.handlesOwnCrud &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge;
        }

        /**
         * Determines and returns if the maintenance form is in a state that will allow an undelete.
         * @return {boolean}
         */
        get canUndelete(): boolean {
            return this.isReadonly &&
                this.itemId !== Guid.empty &&
                this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection && !this.selectedSection.handlesOwnCrud &&
                this.selectedSection.model.objectState === Model.ObjectStateEnum.Deleted;

        }

        /**
         * Determines and returns if the maintenance form is in a state that will allow copying.
         * @return {boolean}
         */
        get canCopy(): boolean {
            return this.isReadonly &&
                this.itemId !== Guid.empty &&
                this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection && !this.selectedSection.handlesOwnCrud &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge;
        }

        //CO can copy an item owned by co at co location only.
        //Non-CO can copy any item.
        get canCoCopy(): boolean {
            if (this.identityService.inCentralOfficeMode())
                return this.selectedSection.model.homeLocationId === this.selectedSection.model.locationId && this.selectedSection.model.homeLocationId === this.identityService.current().centralOfficeId;
            else
                return true;
        }

        /**
         * Determines and returns if the maintenance form is in a state that will allow saving.
         * @return {boolean}
         */
        get canSave(): boolean {
            return this.isAdding || this.isCopying ||
                (this.isEditing &&
                    this.itemId !== Guid.empty &&
                    this.selectedSection !== null && !this.selectedSection.handlesOwnCrud);
        }

        /**
         * Determines and returns if the maintenance form is in a state that will allow cancelling.
         * @return {boolean}
         */
        get canCancel(): boolean {
            return this.isAdding || this.isCopying ||
                (this.isEditing &&
                    this.itemId !== Guid.empty &&
                    this.selectedSection !== null && !this.selectedSection.handlesOwnCrud);
        }

        /**
         * Determines whether or not the Maintenance Form should show the top level 'Edit' option.
         * @return {boolean}
         */
        get showEdit(): boolean {
            return this.showEditLogic();
        }

        /**
         * Function which determins wether to show the 'Edit' option.
         * this was introduced to allow overriding the show edit logic.
         */
        showEditLogic(): boolean {
            return this.verifySelectedSectionModel() && !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge;
        }

        /**
         * Determines whether or not the Maintenance Form should show the top level 'Delete' option.
         * @return {boolean}
         */
        get showDelete(): boolean {
            return this.showDeleteLogic();
        }

        /**
         * Function which determins wether to show the 'Delete' option.
         * this was introduced to allow overriding the show delete logic.
         */
        showDeleteLogic(): boolean {
            return this.verifySelectedSectionModel() &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                this.selectedSection.isPrimarySection &&
                this.isReadonly;
        }

        /**
         * Determines whether or not the Maintenance Form should show the top level 'Undelete' option.
         * @return {boolean}
         */
        get showUndelete(): boolean {
            return this.showUndeleteLogic();
        }

        /**
         * Function which determins wether to show the 'UnDelete' option.
         * this was introduced to allow overriding the show undelete logic.
         */
        showUndeleteLogic(): boolean {
            return this.verifySelectedSectionModel() &&
                this.selectedSection.model.objectState === Model.ObjectStateEnum.Deleted &&
                this.selectedSection.isPrimarySection &&
                this.isReadonly;
        }


        /**
         * Determines whether or not the Maintenance Form should show the top level 'Copy' option.
         * @return {boolean}
         */
        get showCopy(): boolean {
            return this.showCopyLogic();
        }

        /**
         * Function which determins wether to show the 'Copy' option.
         * this was introduced to allow overriding the show copy logic.
         */
        showCopyLogic(): boolean {
            return this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection && !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                this.canCoCopy;
        }

        /**
         *  Function which determins wether to show the 'Add new in Footer' option.
         * @returns {} 
         */
        get showFooterAddNew(): boolean {
            return this.showFooterAddNewLogic();
        }

        /**
         * Function which determins wether to show the 'Copy' option.
         * this was introduced to allow overriding the show copy logic.
         */
        showFooterAddNewLogic(): boolean {
            return this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection &&
                !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                this.selectedSection.sectionId == 0;
        }

        /**
         * Determines whether or not the Maintenance Form should show the top level 'Cancel' option.
         * @return {boolean}
         */
        get showCancel(): boolean {
            return this.showCancelLogic();
        }

        /**
         * Function which determins wether to show the 'Cancel' option.
         * this was introduced to allow overriding the show cancel logic.
         */
        showCancelLogic(): boolean {
            return this.isAdding ||
                (this.isEditing &&
                    Model.Guard.isSomething(this.selectedSection) && !this.selectedSection.handlesOwnCrud);
        }


        /**
         * Determines whether or not the Maintenance Form should show the top level 'Save' option.
         * @return {boolean}
         */
        get showSave(): boolean {
            return this.showSaveLogic();
        }

        /**
         * Function which determins wether to show the 'Save' option.
         * this was introduced to allow overriding the show save logic.
         */
        showSaveLogic(): boolean {
            return this.isAdding || this.isCopying ||
                (this.isEditing &&
                    Model.Guard.isSomething(this.selectedSection) && !this.selectedSection.handlesOwnCrud);
        }

        /**
         * Determines whether or not we can navigate away from the current section to another one.
         * @return {boolean}
         */
        get navigationBlocked(): boolean {
            return this.isAdding || this.isCopying || this.isEditing || (this.selectedSection && (this.selectedSection.isAdding || this.selectedSection.isEditing));
        }

        protected buildCrudSecurityKeys(baseKey) {
            let whenInCo = this.isApplicationModeCO();
            this.buildCrudSecurityKeysBase(baseKey, true, true, whenInCo, whenInCo, whenInCo);
        }

        /*
         * Uses the base key to builds security keys for the CRUD commands.
         * Edit and Delete keys are always generated.
         * Create and Copy keys can be centralized into the Edit key.
         * CO security keys are optional.
         */
        protected buildCrudSecurityKeysBase(baseKey,
            hasCreateKey = false, hasCopyKey = false, hasChangeAccessKey = false,
            hasChangeOwnerKey = false, hasAvailableToLocationsSecurityKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);

            if (hasChangeAccessKey)
                this.changeAccessSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CHANGEACCESS;

            if (hasChangeOwnerKey)
                this.changeOwnerSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CHANGEOWNER;

            if (hasAvailableToLocationsSecurityKey)
                this.availableToLocationsSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_AVAILABLETOLOCATIONS;
        }

        public verifySelectedSectionModel(): boolean {
            return Model.Guard.isSomething(this.selectedSection)
                && Model.Guard.isSomething(this.selectedSection.model);
        }

        public verifyContextBusinessTypeDetail(): boolean {
            return this.verifySelectedSectionModel()
                && Model.Guard.isSomething(this.selectedSection.model.businessTypeDetail);
        }

        /*
         * Allows access to the model by a particular type of Model.DataMaintenance
         */
        protected castModel<T extends Model.DataMaintenance>(): T {
            return this.verifySelectedSectionModel() ? <T>this.selectedSection.model : undefined;
        }

        /**
         * Determines whether the application is in CO mode
         */
        public isApplicationModeCO(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        /**
    * Determines whether the application is a single location
    */
        public isSingleLocation(): boolean {
            if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                return this.identityService.current().isSingleLocation;
            else
                return false;
        }


        //public isUserHasBusinessTypeIds(): boolean {
        //    return this.verifySelectedSectionModel()
        //        && this.isApplicationModeCO()
        //        && this.identityService.current().userBusinessTypeIds.length >= 0;
        //}

        /**
         * Gets or set businessTypeFilter
         */
        private _businessTypeFilter: any;
        get businessTypeFilter(): any {

            if (this.showAllBusinesType === false) {
                if (Model.Guard.isSomething(this._businessTypeFilter)) {
                    this._businessTypeFilter.includeAllBusinessTypeListItem = this.showAllBusinesType;
                } else {
                    this._businessTypeFilter = {
                        includeAllBusinessTypeListItem: this.showAllBusinesType
                    };
                }
            }

            return this._businessTypeFilter;
        }

        set businessTypeFilter(value: any) {
            this._businessTypeFilter = value;
        }

        /**
         * Gets or set businessTypeFilter_businessTypeAsLocationId
         */
        private _businessTypeAsLocationId: any;
        get businessTypeAsLocationId(): any {
            return this._businessTypeAsLocationId;
        }

        set businessTypeAsLocationId(value: any) {
            this._businessTypeAsLocationId = value;
        }


        get asLocationId(): number {
            return (this.takeOwnership && this.identityService.inCentralOfficeMode()) ? this.identityService.current().centralOfficeId : this._asLocationId;
        }

        set asLocationId(value: number) {
            this._asLocationId = value;
        }


        /**
         * Gets or set takeOwnership
         */
        public getTakeOwnershipValue() {
            return this._takeOwnership;
        }

        private _takeOwnership: boolean;
        get takeOwnership(): boolean {
            return this._takeOwnership;
        }

        set takeOwnership(value: boolean) {
            this._takeOwnership = value;
            // Updated business type based on takeownership
            if (this.verifySelectedSectionModel() && this.allowTakeOwnership)
                this.selectedSection.model.businessTypeDetail = this._takeOwnership ? null : this.businessTypeDetail;
            this.applyBusinessTypeFilter();
            if (value)
                this.clearRelatedEntities();


        }

        //TypeAhead BusinessTypeId
        //Needed to be added when we created the checkbox for Allow Locaitons
        get typeAheadBusinessTypeDetailId(): string {
            if (!this.verifyContextBusinessTypeDetail())
                return null;

            return Model.Guard.returnSomething(this.selectedSection.model.availableToLocations) === false
                ? null
                : this.selectedSection.model.businessTypeDetail.id;
        }

        /**
         * Gets or set the businessType value
         */
        private _businessTypeDetail: Model.BusinessTypeDetail;
        get businessTypeDetail(): Model.BusinessTypeDetail {
            return this._businessTypeDetail;
        }

        set businessTypeDetail(value: Model.BusinessTypeDetail) {
            this._businessTypeDetail = value;
            if (this.verifySelectedSectionModel() && Model.Guard.isSomething(this._businessTypeDetail))
                this.selectedSection.model.businessTypeId = value.id;
            else this.selectedSection.model.businessTypeId = null;
        }

        /**
         * Determines whether takeOwnership is available
         */
        get allowsCentralOfficeOptions(): boolean {
            return this.identityService.inCentralOfficeMode()  // CO mode
                && this.verifyContextBusinessTypeDetail()
                && (this.selectedSection.model.homeLocationId === this.identityService.current().centralOfficeId && (Model.Guard.returnSomething(this.selectedSection.model.availableToLocations) === true)// Owned by CO
                    || (this.selectedSection.model.homeLocationId !== this.identityService.current().centralOfficeId && this.takeOwnership)) // Owned by location, but taking ownership
                && !this.isLocationImpersonating;  // Not impersonating location
        }

        get isAccessible(): boolean {
            return this.verifySelectedSectionModel()
                && (
                    // Entities that are only locally defined don't have a home location id
                    !this.selectedSection.model.homeLocationId
                    ||
                    // CO located in CO owned
                    (this.selectedSection.model.locationId === this.identityService.current().locationId
                        && this.selectedSection.model.homeLocationId === this.identityService.current().locationId)
                    // Adding
                    || (this.isAdding)
                    // In CO mode & location owned
                    || (this.identityService.inCentralOfficeMode() && this.selectedSection.model.homeLocationId === this.selectedSection.model.locationId)
                );
        }

        get isParentAccessible(): boolean {

            return (this.locationId === this.identityService.current().locationId
                && this.homeLocationId === this.identityService.current().locationId)                               /*  If CO*/
                || (this.identityService.inCentralOfficeMode() && this.homeLocationId === this.locationId);         /*  Verifies If CO*/
            /*  Returns CO? true : false*/
        }

        /**
         * Determines whether takeOwnership is available
         */
        get allowTakeOwnership(): boolean {
            return this.identityService.inCentralOfficeMode() // in CO mode
                &&
                !this.isAdding // not adding
                &&
                this.verifySelectedSectionModel() &&
                this.selectedSection.model.homeLocationId !== this.identityService.current().centralOfficeId;

            // not CO owned
        }

        /**
         * Determines whether businessType selection is required
         */
        get isBusinessTypeRequired(): boolean {
            return this.isBusinessTypeRequiredLogic();
        }

        get userHasSingleBusinessType(): Model.DataDetail {
            return this.identityService.userBusinessTypes.length === 1 ? this.identityService.userBusinessTypes[0] : null;
        }

        isBusinessTypeRequiredLogic(): boolean {
            return this.identityService.inCentralOfficeMode() // in CO mode
                && (this.isAdding || (this.isEditing && this.takeOwnership));
        }

        /**
         * Determines whether businessType selection is disabled
         */
        get isBusinessTypeLocked(): boolean {
            if (this.isReadonly) // Reading
                return true;
            else if (this.verifySelectedSectionModel() && !this.isAdding) {
                if (this.selectedSection.model.homeLocationId !== this.identityService.current().centralOfficeId // Not CO owned
                    && this.allowTakeOwnership // allows take ownership
                    && !this.takeOwnership) // not taken
                    return true;
                else if (this.selectedSection.model.homeLocationId === this.identityService.current().centralOfficeId // CO owned
                    && this.selectedSection.model.businessTypeId === this.identityService.current().tenantData.allBusinessTypeId && this.lockAvailableToLocations) // All BT
                    return true;
            }
            else
                return false;
        }

        /**
         * Determines whether businessType selection is hidden
         */
        get isBusinessTypeHidden(): boolean {
            // Not in CO mode OR In CO Mode and not owned
            if (this.identityService.inCentralOfficeMode()
                && this.verifySelectedSectionModel()
                && (this.selectedSection.model.locationId === this.identityService.current().centralOfficeId
                    || this.isAdding
                    || this.takeOwnership))
                return false;
            else
                return true;
        }

        /**
         *  Returns Wheter the item is available at location
         **/
        get isAvailableAtLocation(): boolean {
            return !this.identityService.inCentralOfficeMode() ||
                this.isOwning && this.selectedSection.model.locationId !== this.identityService.current().centralOfficeId
        }

        /**
         * Determines whether the user is impersonating a location for the item.
         */
        get isLocationImpersonating(): boolean {
            return this.identityService.inCentralOfficeMode() && !this.isOwning;
        }

        /*
         * Returns the count of any excluded locations
         */
        get excludedLocationCount(): number {
            if (!this.verifySelectedSectionModel())
                return 0;
            var hasOverrides = <Model.IHasLocationOverride>this.selectedSection.model;
            return Model.Guard.isSomething(hasOverrides)
                && Model.Guard.isSomething(hasOverrides.locationOverride)
                ? hasOverrides.locationOverride.locations.length : 0;
        }

        /**
         * Determines whether item is currently owned
         */
        get isOwning(): boolean {
            return this.verifySelectedSectionModel()
                && this.selectedSection.model.homeLocationId === this.selectedSection.model.locationId; // item owned
        }


        protected getOwnedKey(key: any) {
            return {
                "key": key,
                "owned": this.isOwning
            };
        }

        /**
         * Opens a modal for excluded location selection.
         * @param context
         */
        selectLocations(context: any) {
            if (!this.entityType) {
                throw "Entity type not set on context";
            }

            let template = `<div class=""  >
                            <div>
                                <meevo-multi-location-picker entity-type="${this.entityType}"></meevo-multi-location-picker>
                            </div>
                        </div>`;
            let options: Meevo.Components.Modal.IModalOptions = {
                template: template,
                clickOutsideToClose: false,
                locals: {
                    context: context
                },
                controller: "meevo.components.controls.MultiLocationController",
                controllerAs: "vm"
            }

            this.usageTrackingLog(Meevo.Model.VerbEnum.ConfigureLocations, null);

            this.modalService.showCustom(options);
        }

        buildOverrideFieldList(): void {
            if (this.verifySelectedSectionModel()) {
                var overridesFound = _.filter(this.locationFieldList, (i) => i.checked);
                if (overridesFound) {
                    var hasOverrides = <Model.IHasLocationOverride>this.selectedSection.model;
                    if (Model.Guard.isSomething(hasOverrides.locationOverride)
                        && Model.Guard.isSomething(hasOverrides.locationOverride.overrideFieldList))
                        hasOverrides.locationOverride.overrideFieldList = _.pluck(overridesFound, 'field');
                }
            }
        }

        usageTrackingLog(verbEnum: Meevo.Model.VerbEnum, payload, entityId?: Guid, shortDescription?: string): void {
            if (this.selectedSection.noun && this.selectedSection.noun !== null && !this.preventUsageTracking) {
                var trackingItem = new Meevo.Model.TrackingItem(this.selectedSection.noun, verbEnum, payload, entityId, shortDescription);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        get hasActiveChild(): boolean {
            return false;
        }




        /**
        * search for the storage file URL if model implements FileMetadata
        */
        searchFile(filedata, searchKey, defaultUrl): string {
            let filedetails = undefined;
            if (filedata && filedata.meevoFile != undefined)
            { filedetails = filedata; }
            else
            { filedetails = <Model.IStorageFile>this.selectedSection.model; }

            return Model.StorageFileHelper.searchFile(filedetails, searchKey, defaultUrl);
        }

        hasImageUrl(istoreObj) {
            return Model.StorageFileHelper.hasImageUri(istoreObj);
        }
        hasThumbUrl(istoreObj) {
            return Model.StorageFileHelper.hasThumbUri(istoreObj);
        }
        hasSourceUrl(istoreObj) {
            return Model.StorageFileHelper.hasSourceUri(istoreObj);
        }
        getImageUrl(istoreObj, defaultUri: string) {
            return Model.StorageFileHelper.imageUri(istoreObj, defaultUri);
        }
        getThumbUrl(istoreObj, defaultUri: string) {
            return Model.StorageFileHelper.thumbUri(istoreObj, defaultUri);
        }
        getSourceUrl(istoreObj, defaultUri: string) {
            return Model.StorageFileHelper.sourceUri(istoreObj, defaultUri);
        }

        isCopyStyledAsDisabled(): boolean {
            return false;
        }
    }


}